import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationAnchorTile } from "web_myplann/Inspiration/Components/InspirationAnchorTile";
import type { InspirationAnchor } from "web_myplann/Inspiration/Types/InspirationTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

type Props = {
	anchors: InspirationAnchor[];
	activeKey?: string;
	onSelect: (amount: number) => void;
};

export const InspirationAnchorList: FC<Props> = ({
	anchors,
	activeKey,
	onSelect,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Stack direction="row" gap={theme.spacingTokens.sm}>
			{anchors.map((anchor) => (
				<InspirationAnchorTile
					key={anchor.key}
					icon={anchor.icon}
					label={t(anchor.label)}
					amount={formatInspirationMoney(anchor.displayAmount ?? anchor.amount)}
					selected={anchor.key === activeKey}
					onClick={() => onSelect(anchor.amount)}
				/>
			))}
		</Stack>
	);
};
